<app-response-download [input]="input" [downloadFile]="downloadFile"></app-response-download>
<!-- <app-response-table [input]="input"></app-response-table>
<app-response-chart [input]="input"></app-response-chart> -->
<section *ngIf="!isImportGst">
<p-divider class="py-16"/>
<h2 class="text-primary poppins-medium pt-4">Synopsis of GST Reconciliation</h2>
<div class="mt-12 pb-16">
  <h2 class="poppins-medium text-gray-500">GST Reconciliation of Books with GSTR - 2B</h2>

  <div class="mt-16">
    <app-reconciliation-table [input]="input"></app-reconciliation-table>
  </div>
</div>

<div class="pt-8">
  <p-divider/>
</div>

<div class="mt-12 pb-16">
  <h2 class="poppins-medium text-gray-500">Books Summary</h2>
  <div class="flex justify-between flex-wrap gap-8">
    <div class="flex-1">
      <table
      class="mt-4 table-auto border-collapse border shadow-md border-gray-400 w-full max-w-[100vw] overflow-x-auto text-center">
      <thead class="bg-primary text-white">
        <tr>
          <th class="border border-gray-400 p-3">Particulars</th>
          <th class="border border-gray-400 p-3">Total Rows</th>
          <th class="border border-gray-400 p-3">IGST</th>
          <th class="border border-gray-400 p-3">CGST</th>
          <th class="border border-gray-400 p-3">SGST</th>
          <th class="border border-gray-400 p-3">Total Gst</th>
        </tr>
      </thead>
      <tbody>

        <tr >
          <td class="border border-gray-400 p-3">Matched Book Entries</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.matched_entries?.total_rows | indianNumber  }}</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.matched_entries?.igst  | indianNumber  }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.matched_entries?.cgst | indianNumber }}</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.matched_entries?.sgst | indianNumber }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.matched_entries?.total_gst | indianNumber }}</td>
        </tr>
        <tr class="bg-gray-200">
          <td class="border border-gray-400 p-3">Unmatched Book Entries</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.unmatched_entries?.total_rows | indianNumber }}</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.unmatched_entries?.igst | indianNumber }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.unmatched_entries?.cgst | indianNumber }}</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.unmatched_entries?.sgst | indianNumber }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.unmatched_entries?.total_gst | indianNumber  }}</td>
        </tr>
        <tr>
          <td class="border border-gray-400 p-3">Total Book Entries</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.total_entries?.total_rows | indianNumber}}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.total_entries?.igst | indianNumber }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.total_entries?.cgst | indianNumber }}</td>
          <td class="border border-gray-400 p-3 ">{{ bookSummary?.total_entries?.sgst | indianNumber  }}</td>
          <td class="border border-gray-400 p-3">{{ bookSummary?.total_entries?.total_gst | indianNumber }}</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="chartData" class="w-2/5 book-summary-chart">
      <label class="flex justify-center mb-4 poppins-medium text-gray-500">Matched / Unmatched</label>
      <p-chart [options]="pieChartOptions" [data]="chartData" type="doughnut"/>
    </div>
  </div>


    <div class="pt-8">
      <p-divider/>
    </div>

    <div class="mt-12 pb-16">
      <h2 class="poppins-medium text-gray-500">Match Percentage</h2>
      <div *ngIf="gstChartMatched.length" class="grid justify-between w-full md:grid-cols-3 mt-16 gap-8">
        <ng-container *ngFor="let chart of gstChartMatched">
          <div class="rounded-md shadow-lg">
            <label class="flex justify-center mb-4 poppins-medium text-gray-500">{{chart.title}}</label>
            <p-chart [options]="chart.options" [data]="chart.data" [type]="chart.chartType"/>
          </div>
        </ng-container>
      </div>
    </div>

  <div class="pt-8">
    <p-divider/>
  </div>
  <div class="mt-12 pb-16">
    <h2 class="poppins-medium text-gray-500">Summarization</h2>
    <div *ngIf="gstChartSummary.length" class="grid justify-between w-full md:grid-cols-3 mt-16 gap-8">
      <ng-container *ngFor="let chart of gstChartSummary">
        <div class="rounded-md shadow-lg ">
          <label class="flex justify-center mb-4 poppins-medium text-gray-500">{{chart.title}}</label>
          <p-chart [options]="chart.options" [data]="chart.data" [type]="chart.chartType"/>
        </div>
      </ng-container>
    </div>
  </div>
</div>
</section>
